<template>
  <div class="thematics-grid">
    <CheckboxButton
      v-for="subThematic in filteredSubThematicList"
      v-show="!subThematic.checked"
      :key="subThematic._id"
      :color="'white'"
      tabindex="0"
      v-focus
      v-model:checked="subThematic.checked"
      :disabled="disabled"
    >
      {{ subThematic.name }}
    </CheckboxButton>
  </div>
</template>

<script setup lang="ts">
import { computed, watchEffect } from "vue";
import CheckboxButton from "@follaw-fr/components/reusable/atoms/CheckboxButton.vue";
import type { SubThematicReference } from "@commons/types/api/schema.types";
import { searchNormalized } from "@follaw-fr/utils/helper.utils";

type SelectableSubThematic = SubThematicReference & {
  checked?: boolean;
};

type MultipleCheckProps = {
  subThematicList: SelectableSubThematic[];
  searchQuery?: string;
  disabled?: boolean;
};

const { subThematicList, searchQuery = "" } = defineProps<MultipleCheckProps>();

// Un défaut de type tableau se donne en fabrique, sinon toutes les instances
// du composant partageraient le même tableau.
const selectedSubThematicList = defineModel<SelectableSubThematic[]>({
  default: () => [],
});

const filteredSubThematicList = computed(() =>
  subThematicList.filter((item) => searchNormalized(item.name, searchQuery))
);

watchEffect(() => {
  selectedSubThematicList.value = subThematicList.filter(
    (subThematic) => subThematic.checked
  );
});
</script>

<style scoped>
.thematics-grid {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
</style>
